"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSpargeVolume = exports.calcMashGrainWeight = exports.recalculateMashSteps = void 0;
const utils_1 = require("./utils");
const units_1 = require("./units");
const timing_1 = require("./timing");
const grainVolume = 0.652; // l/kg
const boilingTemp = 100;
const maltSpecificHeat = 0.38; // Cal/gram-C
const initialWaterGrainRatio = 2.5; // l/kg
const adjustTunMass = (tunVolume, totVolume, tunMass) => {
    tunVolume = tunVolume * 0.8;
    return tunVolume > 0 && totVolume < tunVolume
        ? (tunMass * totVolume) / tunVolume
        : tunMass;
};
const calcDecoctionStep = (startTemp, targetTemp, startVolume, mashGrainWeight, tunMass = 0, tunSpecificHeat = 0, tunVolume = 0) => {
    const totVolume = grainVolume * mashGrainWeight + startVolume;
    const adjustedTunMass = adjustTunMass(tunVolume, totVolume, tunMass);
    let fraction = (((maltSpecificHeat * mashGrainWeight +
        tunSpecificHeat * adjustedTunMass +
        startVolume) /
        (maltSpecificHeat * mashGrainWeight + startVolume)) *
        (targetTemp - startTemp)) /
        (boilingTemp - startTemp);
    if (fraction > 1) {
        fraction = 1;
    }
    return { amount: { value: totVolume * fraction, unit: 'l' } };
};
const calcInfusionStep = (startTemp, stepTemp, startVolume, index, mashGrainWeight) => {
    const infuseTemp = index > 0
        ? boilingTemp
        : (maltSpecificHeat * (stepTemp - startTemp)) / initialWaterGrainRatio +
            stepTemp;
    const infuseAmount = ((mashGrainWeight * maltSpecificHeat + startVolume) *
        (stepTemp - startTemp)) /
        (infuseTemp - stepTemp);
    return {
        infuse_temperature: {
            unit: 'C',
            value: infuseTemp,
        },
        amount: {
            unit: 'l',
            value: infuseAmount,
        },
    };
};
function recalculateMashSteps(mash_steps, grain_temperature, mashGrainWeight) {
    let startVolume = 0;
    let startTemp = grain_temperature.value;
    const grainWeightValue = units_1.convertMeasurableValue(mashGrainWeight, 'kg');
    return mash_steps.map((step, index) => {
        const stepTemp = utils_1.getMeasurableValue(step.step_temperature);
        switch (step.type) {
            case 'decoction': {
                const { amount } = calcDecoctionStep(startTemp, stepTemp, startVolume, grainWeightValue);
                return Object.assign(Object.assign({}, step), { amount });
            }
            case 'infusion': {
                const { amount, infuse_temperature } = calcInfusionStep(startTemp, stepTemp, startVolume, index, grainWeightValue);
                startVolume += amount.value;
                startTemp = stepTemp;
                return Object.assign(Object.assign({}, step), { infuse_temperature,
                    amount });
            }
            default:
                return step;
        }
    });
}
exports.recalculateMashSteps = recalculateMashSteps;
const calcMashGrainWeight = (fermentables) => {
    const value = utils_1.sum(fermentables.map(({ timing, type, amount }) => type === 'grain' && timing_1.use(timing).add_to_mash
        ? units_1.convertMeasurableValue(amount, 'lb')
        : 0));
    return {
        value,
        unit: 'lb',
    };
};
exports.calcMashGrainWeight = calcMashGrainWeight;
function updateSpargeVolume(mash_steps, spargeVolume) {
    return mash_steps.map((step) => {
        if (step.type === 'sparge') {
            return Object.assign(Object.assign({}, step), { amount: spargeVolume });
        }
        return step;
    });
}
exports.updateSpargeVolume = updateSpargeVolume;
//# sourceMappingURL=mash.js.map